import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/svg/pp_logo.svg'
import _imports_1 from '../assets/svg/basket.svg'
import _imports_2 from '../assets/img/pp-profile-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "bagCount"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_2,
  style: {"width":"100%"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sign In")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Sign Up")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!

  return (_openBlock(), _createBlock(_component_ion_header, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_grid, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center mw-xl ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXl: "2",
                sizeLg: "2",
                sizeMd: "3",
                sizeSm: "6",
                sizeXs: !_ctx.user ? 12 : 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["sizeXs"]),
              _createVNode(_component_ion_col, {
                sizeXl: "6",
                sizeLg: "6",
                class: "ion-hide-lg-down"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SearchBar)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXl: "4",
                sizeLg: "4",
                sizeMd: "9",
                sizeSm: "6",
                sizeXs: !_ctx.user ? 12 : 6,
                class: "bag-account"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_button, {
                    fill: "clear",
                    onClick: _ctx.openBasket,
                    class: "basket placeholder-circle fill-img"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      (_ctx.bagCount > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.bagCount), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, _ctx.showBasket]
                  ]),
                  (_ctx.user)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/account",
                        class: "loginout placeholder-circle"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.user.profile_image)
                            ? (_openBlock(), _createBlock("img", _hoisted_4))
                            : _createCommentVNode("", true),
                          (_ctx.user.profile_image)
                            ? (_openBlock(), _createBlock("img", {
                                key: 1,
                                src: _ctx.user.profile_image,
                                style: {"width":"100%"}
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.user)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: "/sign-in",
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, { color: "secondary" }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.user)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: "/register",
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, null, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["sizeXs"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, {
            sizeXs: "12",
            sizeXl: "5",
            class: "ion-hide-lg-up"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SearchBar)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}